import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import {
  createOrganizationSlice,
  OrganizatinSlice,
} from "./slices/organization";
import { createAuthSlice, AuthSlice } from "./slices/auth";
import { createListsSlice, ListsSlice } from "./slices/lists";
import {
  createLocaleSlice,
  getInitialLocale,
  LocaleSlice,
} from "./slices/locale";
import {
  createListTemplatesSlice,
  ListTemplatesSlice,
} from "./slices/list-templates";
import { createListSlice, ListSlice } from "./slices/list";
import {
  createListEntitiesSlice,
  ListEntitiesSlice,
} from "./slices/list-entities";
import { createListUserSlice, ListUserSlice } from "./slices/list-user";
import {
  createListTemplateSlice,
  ListTemplateSlice,
} from "./slices/list-template";

export const useStore = create<
  AuthSlice &
    OrganizatinSlice &
    ListsSlice &
    ListTemplatesSlice &
    ListTemplateSlice &
    LocaleSlice &
    ListSlice &
    ListEntitiesSlice &
    ListUserSlice
>()(
  devtools(
    persist(
      (...a) => ({
        ...createAuthSlice(...a),
        ...createOrganizationSlice(...a),
        ...createListsSlice(...a),
        ...createListTemplatesSlice(...a),
        ...createListTemplateSlice(...a),
        ...createLocaleSlice(...a),
        ...createListSlice(...a),
        ...createListEntitiesSlice(...a),
        ...createListUserSlice(...a),
      }),
      {
        name: "sidonnaisuudet",
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
);

// NOTE: you have to manually add stuff here
export const resetStore = () => {
  useStore.setState((state) => ({
    ...state,
    authenticated: false,
    accessToken: undefined,
    refreshToken: undefined,
    authAdmin: undefined,
    authListUser: undefined,
    list: undefined,
    listUser: undefined,
    lists: [],
    listEntities: [],
    listTemplate: undefined,
    listTemplates: [],
    locale: getInitialLocale(),
  }));
};
